import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getGramatuPiegadeExpiry, getProducts, getGramatuPiegadeCoupon, reset, setGramatuPiegadeExpiry } from '../features/order/orderSlice';
import { useNavigate } from 'react-router-dom';
import Spinner from '../components/Spinner';
import { FaTimes } from 'react-icons/fa'; // Import FaTimes icon

function FreeShipping() {
    const dispatch = useDispatch();

    const [selectedProducts, setSelectedProducts] = useState([]);

    const { gramatu_piegade, products, coupons, isLoading } = useSelector(
        (state) => state.order
    ); 

    useEffect(() => {
        dispatch(getProducts());
        dispatch(getGramatuPiegadeCoupon());
        dispatch(getGramatuPiegadeExpiry());
    }, []);

    useEffect(() => {
        if (gramatu_piegade && gramatu_piegade.length > 0 && products && products.length > 0) {
            const selectedProductsWithNames = gramatu_piegade.map(gramatuPiegadeDiscount => {
                const product = products.find(product => product.id === gramatuPiegadeDiscount.product_id);
                return {
                    ...gramatuPiegadeDiscount,
                    name: product ? product.name : 'Nezināms produkts',
                    expiry_date: gramatuPiegadeDiscount.expiry_date || new Date().toISOString() // Fallback to current date
                };
            });
    
            setSelectedProducts(selectedProductsWithNames);
        }
    }, [gramatu_piegade, products]);

    const handleCheckboxChange = (productId) => {
        const isSelected = selectedProducts.some(selectedProduct => selectedProduct.product_id === productId);

        if (isSelected) {
            setSelectedProducts(selectedProducts.filter(gramatuPiegadeDiscount => gramatuPiegadeDiscount.product_id !== productId));
        } else {
            const product = products.find(product => product.id === productId);
            if (product) {
                setSelectedProducts([
                    ...selectedProducts,
                    {
                        product_id: productId,
                        name: product.name,
                        expiry_date: new Date().toISOString() // Default expiry date
                    }
                ]);
            }
        }
    };

    const handleDateChange = (productId, newDate) => {
        // Check if the newDate is a valid date
        const isValidDate = !isNaN(new Date(newDate).getTime());
    
        if (isValidDate) {
            setSelectedProducts(selectedProducts.map(gramatuPiegadeDiscount => 
                gramatuPiegadeDiscount.product_id === productId
                    ? { ...gramatuPiegadeDiscount, expiry_date: newDate }
                    : gramatuPiegadeDiscount
            ));
        } else {
            console.warn(`Invalid date input: ${newDate}`);
        }
    };

    const handleDelete = (productId) => {
        const confirmDelete = window.confirm('Vai tiešām vēlaties dzēst šo produktu no saraksta?');
        if (confirmDelete) {
            setSelectedProducts(selectedProducts.filter(gramatuPiegadeDiscount => gramatuPiegadeDiscount.product_id !== productId));
        }
    };

    const publishChanges = () => {
        const selected_products = selectedProducts.map(gramatuPiegadeDiscount => ({
            product_id: gramatuPiegadeDiscount.product_id,
            expiry_date: gramatuPiegadeDiscount.expiry_date
        }));

       dispatch(setGramatuPiegadeExpiry(selected_products));
    };

    if (isLoading || !products || products.length < 1 || !coupons) {
        return <Spinner />;
    }

    return (
        <div className='gift-card-management padding-20-bottom'>
            <h2 className="light padding-20-top">Bezmaksas piegādes portāls</h2>

            <button 
                className="btn publish-changes-btn margin-10-bottom" 
                onClick={publishChanges}
            >
                Publicēt izmaiņas
            </button>

            <div className="flex column gap-10 padding-10-bottom gramatu-piegade-produkti">
                <b>Izvēlēties produkti</b>
                <div className="flex gap-5 column" style={{ overflowY: 'scroll' }}>
                    {selectedProducts && selectedProducts.length > 0 && selectedProducts.map((gramatuPiegadeDiscount) => (
                        <div key={gramatuPiegadeDiscount.product_id} className="flex gap-10 align-center">
                            <li>{gramatuPiegadeDiscount.name}</li>
                            <input 
                                value={new Date(gramatuPiegadeDiscount.expiry_date).toISOString().split('T')[0]} 
                                type="date" 
                                onChange={(e) => handleDateChange(gramatuPiegadeDiscount.product_id, e.target.value)} 
                            />
                            <FaTimes 
                                className="delete-icon" 
                                onClick={() => handleDelete(gramatuPiegadeDiscount.product_id)} 
                                style={{ color: 'red', cursor: 'pointer' }} 
                            />
                        </div>
                    ))}
                </div>
            </div>

            {products && 
                <>
                    {products.map((product) => (
                        <div className="flex gap-10" key={product.id}>
                            <input
                                type="checkbox"
                                name=""
                                id=""
                                onChange={() => handleCheckboxChange(product.id)}
                                checked={selectedProducts.some(selectedProduct => selectedProduct.product_id === product.id)}
                            />
                            <p>{product.name}</p>
                        </div>
                    ))}
                </>
            }
        </div>
    );
}

export default FreeShipping;